import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {PlatformComponent} from './platform.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PlatformComponent
  ],
  exports: [
    PlatformComponent
  ],
  providers: []
})
export class PlatformModule {
}
